import {Service, service, inject} from "./di";
import { FlyerService } from "./FlyerService";
import { LocationService } from "./LocationService";
import { Flyer } from "../definitions/FlyerDefinitions";
import { SeoService } from "./SeoService";
import { LinkService } from "./LinkService";
import MetadataService from "./MetadataService";
import {slugify} from "../utils/slugify";
import MerchantService from "./MerchantService";

@service
export class ExpiredCanonicalsService extends Service {
	@inject flyerService: FlyerService;
	@inject location: LocationService;
	@inject seoService: SeoService;
	@inject linkService: LinkService;
	@inject metadataService: MetadataService;
	@inject merchantsService: MerchantService;

	async getFlyersLink(): Promise<string> {
		const merchantNames = this.getMerchantNamesFromUrl();
		const flyers = await this.findMerchant([...merchantNames]);
		const locale = this.seoService.locale;
		if (flyers.length === 0) {
			const data = await this.merchantsService.getAllMerchants(locale);
			const store = data.merchants.find((m: any) => {
				const merchantName = slugify(m.name);
				const c = merchantNames.find(mn => {
					return mn.includes(merchantName) || mn.includes(slugify(merchantName));
				});
				return Boolean(c);
			});
			const storeName =  store ? slugify(store.name) : merchantNames[0];
			const link = `/${locale}/${this.location.getInCity()}`;
			return locale === "en-us" ? `${link}/weekly_ads` : `${link}/stores/${storeName}`;
		}
		const flyer = flyers.pop();
		return this.linkService.linkTo(flyer);
	}

	async getCouponsLink(): Promise<string> {
		return `/${this.metadataService.getLocale()}/${this.location.getInCity()}/coupons`;
	}

	async findMerchant(merchantNames: string[]): Promise<Flyer[]> {
		while (merchantNames.length > 0) {
			const merchantName = merchantNames.pop();
			const flyers = await this.flyerService.getFlyersByMerchantName(merchantName);
			if (flyers.length > 0) {
				return flyers;
			}
		}

		return [];
	}

	getMerchantNamesFromUrl() {
		const names = [];
		const flyerIdAndName = window.location.pathname.split("/").pop();
		const flyerIdAndNameSplitted = flyerIdAndName.split("-");
		flyerIdAndNameSplitted.shift();

		while (flyerIdAndNameSplitted.length > 0) {
			const name = flyerIdAndNameSplitted.reduce((result, value) =>
				result.length === 0 ? `${value}` : `${result}-${value}`
				, ""
			);
			names.push(name);
			flyerIdAndNameSplitted.pop();
		}

		return names;
	}

}

